import { createContext, useContext as useReactContext } from "react";
import { getPathParams } from "../utilities";
import { useLayoutSettings } from "./useLayoutSettings";
import { useHandler } from "./useHandler";
import { usePreviewAnswers } from "./usePreviewAnswers";

export const Context = createContext({
  isLoading: false,
  isError: false,
  isPublished: false,
  title: {
    value: "",
    set: () => {},
  },
  focusedBlock: {
    id: undefined,
    set: () => {},
  },
  layout: {
    params: {
      isOpen: false,
      toggle: () => {},
    },
    preview: {
      isFullView: false,
      toggle: () => {},
    },
  },
  blocks: {
    unwrap: () => {},
    create: () => {},
    update: () => {},
    getCurrent: () => ({}),
    getCurrentIndex: () => -1,
    delete: () => {},
    duplicate: () => {},
    reorder: () => {},
    isRequired: () => false,
    focusNextBlock: () => {},
  },
  previewAnswers: {
    get: () => "",
    set: () => {},
    remove: () => {},
    isAnswered: () => false,
    getComment: () => "",
    setComment: () => {},
  },
  isStateChanged: () => false,
  blockErrors: {
    set: () => {},
    has: () => {},
    clear: () => {},
    get: () => {},
  },
  blockListRef: {
    init: () => {},
    scrollTo: () => {},
    reset: () => {},
  },
});

export const useContextValue = () => ({
  ...useHandler(),
  layout: useLayoutSettings(),
  previewAnswers: usePreviewAnswers(),
});

export const useContext = () => {
  const context = useReactContext(Context);
  const { surveyId, isEditMode } = getPathParams();

  return {
    id: surveyId,
    isEditMode,
    ...context,
  };
};
